import { getScrollTop, setScrollTop } from "./scroll"

const savedScrollPositions = {}

export function saveScrollPosition(pageId) {
  savedScrollPositions[pageId] = getScrollTop()
  // console.log('saveScrollPosition', {pageId, savedPosition: savedScrollPositions[pageId]});
}

export function recoverScollPosition(pageId) {
  const savedPosition = savedScrollPositions[pageId] || 0
  fixScrollTop(savedPosition)
  // console.log('recoverScollPosition', {pageId, savedPosition});
  setScrollTop(savedPosition)
}

/**
 * Фиксирует положение скролла в течении определенного времени
 * Нужно для браузеров, которые применяют сохраненный ранее скролл для страницы плавно
 *
 * @param {number} scrollTop
 * @param {number} fixPeriod
 */
export function fixScrollTop(scrollTop = 0, fixPeriod = 1000) {
  let isWheel = false

  setScrollTop(scrollTop)

  window.addEventListener("scroll", fixScroll)
  window.addEventListener("wheel", handleMouseWheel)

  setTimeout(() => {
    window.removeEventListener("scroll", fixScroll)
    window.removeEventListener("wheel", handleMouseWheel)
  }, fixPeriod)

  function fixScroll() {
    if (!isWheel) {
      setScrollTop(scrollTop)
    }
  }

  function handleMouseWheel() {
    isWheel = true
  }
}
